import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Layout, Typography, Card } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import TramittaLogo from '../../../images/tramitta-logo.png';
import LegalChileLogo from '../../../images/legalchile.svg';
import YapoLogo from '../../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../../config/constants/urls';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;
const { Title } = Typography;

const WebpayRejected = ({ sourceUrl }) => {

  useEffect(() => { sessionStorage.removeItem('contractId'); }, []);

  return (
    <React.Fragment id="transaction-canceled">
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          {sourceUrl === EXTERNAL_URL.YAPO &&
            <img src={YapoLogo} alt="" className="yapo-logo" />
          }
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <Content className="ant-layout-content-custom">
        <Row className="mb-4">
          <Col md={12} className="text-center mx-auto">
            <FileOutlined style={{ fontSize: '40px', color: '#160B9F' }} className="mb-2" />
            <Title level={1}>Compra anulada</Title>
          </Col>
        </Row>
        <Row>
          <Col md={18} lg={9} className="mx-auto position-relative">
            <Card xs={18} md={6} className="mx-auto mb-4">
              <Title className="text-center mb-2" level={4}>La compra ha sido anulada.</Title>
              <Title className="text-center mb-2" level={5}>Gracias por usar Tramitta.</Title>
            </Card>
          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
};

WebpayRejected.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  sourceUrl: state.contract.sourceUrl
});

export default connect(data, null)(WebpayRejected);